<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    (click)="openConnectModal()"
    sbTooltip="{{ 'lang.clientManagement.newClientConnection' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<ng-template [sbmodal]="ConnectClientModalID">
  <sb-custom-modal [templateId]="ConnectClientModalID">
    <div slot="body">
      <sb-page-create-client-connection (done)="onClientConnected()"></sb-page-create-client-connection>
    </div>
  </sb-custom-modal>
</ng-template>

<!------------------------------

  Table Wrapper

------------------------------->

<div class="tw-min-h-[500px]">
  <sb-table-wrapper-new
    headline="{{'lang.globals.connectedClients' | translate}}"
    [isInIntegratedContext]="true"
    [itemsData]="connectedClients"
    (paginationChange)="requestDebounced($event)"
    [loading]="loading()"
    [itemName]="'clients'">

    <!------------------------------

      Filter Panel

  ------------------------------->

    <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
      <sb-filter-panel
        (filterChange)="applyFiltering($event)"
        [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
        [config]="filterConfig"
      >

      </sb-filter-panel>
    </div>

    <!------------------------------

          Table Header

    ------------------------------->
    <ng-template #thead>
      <tr>
        <th>
          {{ 'lang.globals.id' | translate }}
        </th>
        <th>
          {{ 'lang.globals.name' | translate }}
        </th>
        <th>
          {{ 'lang.globals.createdAt' | translate }}
        </th>
        <th>
          {{ 'lang.address.street' | translate }}
        </th>
        <th>
          {{ 'lang.address.city' | translate }}
        </th>
        <th class=" sticky-col last-col tw-z-20">
          {{ 'lang.globals.action' | translate }}
        </th>
      </tr>
    </ng-template>
    <!------------------------------

  Table Body

  ------------------------------->
    <ng-template #tbody let-client>
      <tr>
        <td>
          {{ client?.requested?.id }}
        </td>
        <td>
          <sb-comp-image-name-wrapper [image]="client?.requested?.logo?.url" [still]="true">
            <div firstLine>{{ client?.requested?.name }}</div>
          </sb-comp-image-name-wrapper>
        </td>
        <td>
          {{ client?.createdAt | date: 'dd.MM.yy HH:mm:ss' }}
        </td>
        <td>
          {{ client?.requested?.address?.street }}
        </td>
        <td>
          {{ client?.requested?.address?.city }}
        </td>
        <td class="sticky-col last-col">
          <sb-split-button
            [splitButtonItems]="client.sbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(client, $event)"
          ></sb-split-button>
        </td>
      </tr>
    </ng-template>
    <!------------------------------

      Card Element

  ------------------------------->
    <!-- No card element -->

  </sb-table-wrapper-new>
</div>
